import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const rootApi = createApi({
  reducerPath: 'rootApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'api/' }),
  // All tag types must go here
  tagTypes: ['FormData', 'TableData', 'TemplateData'],
  endpoints: () => ({}),
})
